import { type ObjectValuesUnionType } from '../utils/typing';

const PeriodIds = Object.freeze({
  PERIOD_ID_NOT_STARTED: 0,
  PERIOD_ID_1ST_PERIOD: 1,
  PERIOD_ID_2ND_PERIOD: 2,
  PERIOD_ID_3RD_PERIOD: 3,
  PERIOD_ID_FIRST_HALF: 6,
  PERIOD_ID_SECOND_HALF: 7,
  PERIOD_ID_1ST_SET: 8,
  PERIOD_ID_2ND_SET: 9,
  PERIOD_ID_3RD_SET: 10,
  PERIOD_ID_4TH_SET: 11,
  PERIOD_ID_5TH_SET: 12,
  PERIOD_ID_1ST_QUARTER: 13,
  PERIOD_ID_2ND_QUARTER: 14,
  PERIOD_ID_3RD_QUARTER: 15,
  PERIOD_ID_4TH_QUARTER: 16,
  PERIOD_ID_HALF_TIME: 30,
  PERIOD_ID_SOCCER_HALF_TIME: 31,
  PERIOD_ID_SOCCER_END_REGULAR_TIME: 32,
  PERIOD_ID_SOCCER_OVERTIME_HALF_TIME: 33,
  PERIOD_ID_SOCCER_BEFORE_PSO: 34,
  PERIOD_ID_OVERTIME: 40,
  PERIOD_ID_SOCCER_OVERTME_FIRST_HALF: 41,
  PERIOD_ID_SOCCER_OVERTME_SECOND_HALF: 42,
  PERIOD_ID_PSO_START: 50,
  PERIOD_ID_INTERRUPTED: 80,
  PERIOD_ID_ABANDONED: 90,
  PERIOD_ID_ENDED: 100,
  PERIOD_ID_ENDED_AFTER_OVERTIME: 110,
  PERIOD_ID_ENDED_AFTER_PSO: 120,
  PERIOD_ID_BASKET_1ST_BREAK: 301,
  PERIOD_ID_BASKET_2ND_BREAK: 302,
  PERIOD_ID_BASKET_3RD_BREAK: 303,
  PERIOD_ID_BASKET_4TH_BREAK: 304,
});

export default PeriodIds;

export type PeriodId = ObjectValuesUnionType<typeof PeriodIds>;
